import { Link } from 'react-router-dom';

export function Logo() {
  return (
    <Link
      to="/"
      className="flex items-center hover:opacity-90 transition"
    >
      <picture>
        <source srcSet="/logo-384.webp" type="image/webp" />
        <img
          src="/logo-384.png"
          alt="LocationOran.com - Locations & Vacances à Oran"
          width={384}
          height={256}
          className="h-20 md:h-24 w-auto object-contain"
        />
      </picture>
    </Link>
  );
}
